import React from 'react';
import PropTypes from 'prop-types';
import { Subtitle2 } from 'components/Typography';
import SwipeListPanel from '../SwipeListPanel';
import { filterTypes } from '../SwipeListPanel';

const EmptyStateMessage = (swipeRetention) => `There have been no spot checks in the past ${swipeRetention} hours`;

class SpotCheckList extends React.Component {

    header() {
        return (<Subtitle2>Spot Checks</Subtitle2>);
    }

    render() {
        return (
            <SwipeListPanel
                HeaderComponent={this.header}
                emptyStateMessage={EmptyStateMessage}
                showEmptyFilterMessage={false}
                swipes={this.props.swipes}
                config={this.props.config}
                location={this.props.location}
                supervisorData={this.props.supervisorData}
                currentFilter={filterTypes.SpotChecks} />
        );
    }
}

SpotCheckList.propTypes = {
    swipes: PropTypes.arrayOf(PropTypes.object).isRequired,
    config: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    supervisorData: PropTypes.object.isRequired
};

export default SpotCheckList;